// TODO: unflatten this? https://github.com/formatjs/react-intl/issues/207
const en_US = {
  // TODO: the 'lang' here is a bit weird
  lang: '简体中文',

  yes: 'Yes',
  no: 'No',

  home: 'Home',
  dashboard: 'Dashboard',
  signIn: 'Sign in',
  signUp: 'Sign up',
  signOut: 'Sign out',
  defaultEmail: 'Default Email',
  notification: 'Notifications',
  setting: 'Setting',

  unknownError: 'Unknown error!',

  userInfoNotExist: 'User information does not exist!',

  sentryFailGet: 'Failed to get sentries',

  notificationSuccessAdd: 'Successfully added!',
  notificationFailAdd: 'Failed to add notification!',
  notificationFailGet: 'Failed to get notifications!',
  notificationInvalidString: 'The input is not valid string!',
  notificationServerChanName: 'Please input your ServerChan name!',
  notificationServerChanSCKEY: 'Please input your SCKEY!',

  dashboardSidebarHome: 'Sentries',
  dashboardSidebarNotifications: 'Notifications',
  dashboardSidebarSetting: 'Settings',

  sentryRemoveText: 'Do you want to remove this sentry?',

  sentryDetailInputName: 'Please input sentry name!',
  sentryDetailInputInterval: 'Please input sentry interval',
  sentryDetailSuccessUpdate: 'Successfully updated!',

  timeZoneDiffNotice:
    'The browser time zone is different from current user setting!',
};
export default en_US;
